import { FeatureFlag } from '../FeatureFlag';

export const useNextGenProxy = new FeatureFlag({
    key: 'use-nextgen-proxy',
    defaultValue: false,
});
